module.exports = __webpack_public_path__ + "img/img_jin@2x.a1cabd89.png";